export default __webpack_public_path__ + "static/media/bbrfaWETH.56844068.png";